import { useEffect } from 'react';

import { adminPharmaciesInfo, getPharmaciesInfo } from '@pharmaplan/common';

import { useAppSelector } from '../../useAppSelector';
import { useAppDispatch } from '../../useAppDispatch';

interface IUseAdminWorkshiftDropdowns {
  pharmacyId?: string;
  useApi?: boolean;
  isAutoSyncRecord?:boolean
}

const useAdminWorkshiftDropdowns = ({
  pharmacyId,
  useApi,
  isAutoSyncRecord,
}: IUseAdminWorkshiftDropdowns) => {
  const dispatch = useAppDispatch();

  const dropdowns = useAppSelector(adminPharmaciesInfo);

  useEffect(() => {
    if (pharmacyId && useApi) {
      dispatch(getPharmaciesInfo({ id: pharmacyId, isAutoSyncRecord }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pharmacyId, useApi]);

  return {
    travelAllowanceDropdown: dropdowns?.travelAllowanceTypes,
    accommodationAllowanceDropdown: dropdowns?.accommodationAllowanceTypes,
  };
};

export default useAdminWorkshiftDropdowns;
